export default __webpack_public_path__ + "images/right-arrow-blue.png?11448c1b473f748fd9230a3f5e7ab8c7";